import { OAuthToRequestPayload } from '../OAuthMapping';
export const getOAuthRequestPayload = (token, provider) => {
  return OAuthToRequestPayload[provider](token);
};